import { PaytrieAPI } from '@paytrie/client'

import { MagicLinkUnauthorizedError } from './MagicLinkUnauthorizedError'

export type ApprovedMagicLink = {
  accessToken: string
  tokenType: PaytrieAPI.ApproveMagicLinkResponseTokenType
  expiresIn: number
}

export const approveMagicLink = async ({
  email,
  verifier,
  sessionId,
}: {
  email: string
  verifier: string
  sessionId?: string
}): Promise<ApprovedMagicLink> => {
  const response = await PaytrieAPI.approveMagicLink(verifier, {
    email,
    sessionId,
  })

  if (response.status === 401) throw new MagicLinkUnauthorizedError()
  if (response.status !== 200) {
    throw new Error(`Magic link approval failed (status ${response.status})`)
  }

  const { accessToken, tokenType, expiresIn } = response.data.data
  return { accessToken, tokenType, expiresIn }
}
